// Web Audio API 합성 사운드
let _ctx: AudioContext | null = null;

function ctx(): AudioContext | null {
  if (!_ctx) {
    try {
      _ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
    } catch {
      return null;
    }
  }
  return _ctx;
}

export function playChop(): void {
  const c = ctx();
  if (!c) return;
  const t0 = c.currentTime;
  const buf = c.createBuffer(1, c.sampleRate * 0.08, c.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < data.length; i++) {
    data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / data.length, 2);
  }
  const src = c.createBufferSource();
  const filt = c.createBiquadFilter();
  filt.type = 'lowpass';
  filt.frequency.value = 1200;
  const gain = c.createGain();
  gain.gain.value = 0.4;
  src.buffer = buf;
  src.connect(filt);
  filt.connect(gain);
  gain.connect(c.destination);
  src.start(t0);
}

export function playGoldChime(): void {
  const c = ctx();
  if (!c) return;
  const t0 = c.currentTime;
  [880, 1175, 1568].forEach((f, i) => {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = 'triangle';
    o.frequency.value = f;
    g.gain.setValueAtTime(0, t0 + i * 0.08);
    g.gain.linearRampToValueAtTime(0.25, t0 + i * 0.08 + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, t0 + i * 0.08 + 0.5);
    o.connect(g);
    g.connect(c.destination);
    o.start(t0 + i * 0.08);
    o.stop(t0 + i * 0.08 + 0.5);
  });
}
